import { render } from "./InstallationType.vue?vue&type=template&id=00ceabd4&scoped=true"
import script from "./InstallationType.vue?vue&type=script&lang=js"
export * from "./InstallationType.vue?vue&type=script&lang=js"

import "./InstallationType.vue?vue&type=style&index=0&id=00ceabd4&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ceabd4"]])

export default __exports__